import { useEffect, useState } from "react";
import "../App.css"
// COMBINATION OF ALPHABETS
import { alphabets } from "./Random";



export const Maincompo=()=>{
  
   
 let l= JSON.parse(localStorage.getItem("bestTime")) ||90000000000;

 const [text,settext] = useState("")
 const [color,setcolor] = useState("Upcom")
 const [dis,setdis] = useState(false)
 const [time,setTime]=useState(0);
 const [timerOn,setTimeOn]=useState(false);
 const [i,seti] = useState(1);
 const [result,setresult] = useState(null)
 const [bestTime,setbestTime] = useState(l)
 // STORING A RANDOM ORDER OF ALPHABETS
 const [arr,setarr] = useState(alphabets[Math.floor(Math.random() * 17)])
 console.log("b",bestTime)
 // TIMER ONLY WHEN THE USER STARTS WRITING
 useEffect(()=>{
   if(timerOn)
   {
       var timer=setInterval(()=>{
            setTime((prev)=>prev+10)
        },10)
   }
   return ()=>{
       
       clearInterval(timer)
   }
},[timerOn])
// RESETS (TIME,TIMER,TEXT,ALPHABETICAL ORDER)
const handleReset=()=>{
   setTime(0);
   setTimeOn()
   settext("")
   seti(1)
   setresult(null)
   setdis(false)
   setcolor("Upcom")
   var checking = Math.floor(Math.random() * 17);
   setarr(alphabets[checking])
}
// STOPS WHEN THE TASK IS COMPLETED AND DISPLAYS THE RESULT ACCORDINGLY
const handleStop=()=>{
   
   setTimeOn(false)

   if(time>bestTime && bestTime==90000000000){
     setbestTime(time)
     setresult("SUCCESS")
     setcolor("sucess")
     localStorage.setItem('bestTime', JSON.stringify(time));
   }
   else if(time<bestTime){
     setbestTime(time)
     setresult("SUCCESS")
     setcolor("sucess")
     localStorage.setItem('bestTime', JSON.stringify(time));
   }else{
     localStorage.setItem('bestTime', JSON.stringify(bestTime)) 
     setresult("FAILURE")
     setcolor("upcom")
   }
 
}

   // CHECK ON EVERY INPUT
 const check=(e)=>{
   settext(e.target.value)
   setTimeOn(true)
   if(arr.slice(0,e.target.value.length)===e.target.value){
      
     if(arr===e.target.value){
       setdis(true)
       
       handleStop()
       return
     }
     seti(e.target.value.length+1)
     setcolor("Upcom")
     return
   }
   setcolor("upcom")
 } 
  
 return (
  
   <div className="App">
     <h1>Type The Alphabet</h1>
     <h3 className='subHeading1'>Typing game to see how fast you type. Timer <br></br>starts when you do :) </h3>
     <h5  className='subHeading2'>Note: Please turn off your CapsLk</h5>
      <div className={color}>{result!==null? result: arr[i-1]}</div>
         {/* DISPLAYING THE CURRENT TIMER */}
     <div className='time'>Time : 
               <span>{("0"+ Math.floor((time/60000)%60)).slice(-2)} m :</span>
               <span>{("0"+ Math.floor((time/1000)%60)).slice(-2)} s :</span>
               <span>{("0"+ ((time/10)%100)).slice(-2)} ms</span>
           </div>
           

       {/*  DISPLAYING THE BEST TIME     */}
       <h4 className='bestTime'>my best time :{bestTime!==90000000000 ? <div >
               <span>{("0"+ Math.floor((bestTime/60000)%60)).slice(-2)} m :</span>
               <span>{("0"+ Math.floor((bestTime/1000)%60)).slice(-2)} s :</span>
               <span>{("0"+ ((bestTime/10)%100)).slice(-2)} ms!</span>
           </div> :" -- -- --"}</h4>   
       
     <input className="input1" onChange={check}  maxLength={i} disabled={dis} value={text} placeholder="Type Here" ></input>
     <button className='ResetButton' onClick={handleReset}>Reset</button>
     
     </div>
     
 );
   
    
}